import { createFileRoute } from '@tanstack/react-router'
import ChangelogPage from 'pages/app/changelog/ChangelogPage'

export const Route = createFileRoute('/_authenticated/app/uppdateringar')({
  component: ChangelogPage,
})
